import { NOT_NAME } from '../../constants';
import { getCapabilityConfigByMethod, NODE_TYPE_NOT } from './capabilityDynamicFieldsConfig';

/**
 * Returns the meshbot node type for a block whose method is present in CAPABILITY_DYNAMIC_FIELDS_CONFIG.
 * Node-agnostic — returns whatever `node` the config declares for that method:
 *  - config.node          — plain block;
 *  - NODE_TYPE_NOT[node]  — negated ("not") block whose nested block uses such a method.
 * Returns undefined when the method is not in the config. Extensible via the config (no changes here for new nodes).
 * @param {string} name - the block's method name
 * @param {Object} value - the block's first field value (the nested block for the "not" case)
 * @returns {string|undefined} node type (e.g. at.DEVICE / at.DEVICE_NOT) or undefined
 */
export const getNodeTypeByMethod = (name, value) => {
    const config = getCapabilityConfigByMethod(name);
    if (config) {
        return config.node;
    }

    if (name === NOT_NAME) {
        const nestedConfig = getCapabilityConfigByMethod(value?.blockOptions?.method?.name);
        if (nestedConfig) {
            return NODE_TYPE_NOT[nestedConfig.node];
        }
    }

    return undefined;
};
